module.exports = __webpack_public_path__ + "static/img/EC.d16fac2c.svg";